"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({idx}) {
        this.idx = idx;
    },
    onMount: function () {
        this.initializePicker();
    },
    initializePicker: function () {
        const self = this;
        setTimeout(() => {
            const $dateInput = $(`.pickadate.idx-${ self.idx }`), $timeInput = $(`.pickatime.idx-${ self.idx }`);
            if ($dateInput.length)
                $dateInput.pickadate({
                    format: 'mmmm dd, yyyy',
                    min: true,
                    onSet: function () {
                        const $this = $('#' + this.get('id'));
                        self.emit('change', self.idx, $this.attr('name'), 'date', this.get());
                    }
                });
            if ($timeInput.length)
                $timeInput.pickatime({
                    formatLabel: 'HH:i a',
                    formatSubmit: 'HH:i',
                    hiddenPrefix: 'prefix__',
                    hiddenSuffix: '__suffix',
                    interval: 30,
                    onSet: function () {
                        const $this = $('#' + this.get('id'));
                        self.emit('change', self.idx, $this.attr('name'), 'time', this.get());
                    }
                });
        }, 1000);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/ScheduleForm/components/DateForm/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    marko_attrs0 = {
        "class": "py-1"
      },
    marko_attrs1 = {
        "class": "col"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "col-md-4 col-12"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "col"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "col-md-4 col-12"
      },
    marko_attrs8 = {
        "class": "form-group"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const { start, end } = input

  _preserve_tag({
      n: true,
      renderBody: function(out) {
        out.be("div", marko_attrs0, "0", component);

        Row_tag({
            renderBody: function(out) {
              out.be("div", marko_attrs1, "2", component);

              out.be("div", marko_attrs2, "3", component);

              out.be("label", null, "4", component);

              Locale_tag({
                  text: "Start Date",
                  class: "text-muted"
                }, out, __component, "5");

              out.ee();

              out.e("input", {
                  type: "text",
                  value: start.date,
                  name: "start",
                  "class": marko_classValue("form-control form-control-lg px-2 pickadate idx-" + input.idx),
                  placeholder: Locale("January 01, 2021")
                }, "6", component, 0);

              out.ee();

              out.ee();

              out.be("div", marko_attrs3, "7", component);

              out.be("div", marko_attrs4, "8", component);

              out.be("label", null, "9", component);

              Locale_tag({
                  text: "Start Time",
                  class: "text-muted"
                }, out, __component, "10");

              out.ee();

              out.e("input", {
                  type: "text",
                  value: start.time,
                  name: "start",
                  "class": marko_classValue("form-control form-control-lg px-2 pickatime idx-" + input.idx),
                  placeholder: "11:30"
                }, "11", component, 0);

              out.ee();

              out.ee();
            }
          }, out, __component, "1");

        Row_tag({
            renderBody: function(out) {
              out.be("div", marko_attrs5, "13", component);

              out.be("div", marko_attrs6, "14", component);

              out.be("label", null, "15", component);

              Locale_tag({
                  text: "End Date",
                  class: "text-muted"
                }, out, __component, "16");

              out.ee();

              out.e("input", {
                  type: "text",
                  value: end.date,
                  name: "end",
                  "class": marko_classValue("form-control form-control-lg px-2 pickadate idx-" + input.idx),
                  placeholder: Locale("January 01, 2021")
                }, "17", component, 0);

              out.ee();

              out.ee();

              out.be("div", marko_attrs7, "18", component);

              out.be("div", marko_attrs8, "19", component);

              out.be("label", null, "20", component);

              Locale_tag({
                  text: "End Time",
                  class: "text-muted"
                }, out, __component, "21");

              out.ee();

              out.e("input", {
                  type: "text",
                  value: end.time,
                  name: "end",
                  "class": marko_classValue("form-control form-control-lg px-2 pickatime idx-" + input.idx),
                  placeholder: "11:30"
                }, "22", component, 0);

              out.ee();

              out.ee();
            }
          }, out, __component, "12");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
